var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFotterImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 270,
    viewBox: "0 0 1440 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_43706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1345 240C1397.47 240 1440 197.467 1440 145C1440 92.5329 1397.47 50 1345 50C1292.53 50 1250 92.5329 1250 145C1250 197.467 1292.53 240 1345 240Z",
    fill: "#2AC9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 0C1380.9 0.040125 1333 47.9293 1333 107C1333 166.071 1380.9 213.96 1440 214V0Z",
    fill: "#03B79E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 275C490.405 275 511 254.405 511 229C511 203.595 490.405 183 465 183C439.595 183 419 203.595 419 229C419 254.405 439.595 275 465 275Z",
    fill: "#2AC9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 62V178.065C25.8723 171.436 44.9953 147.971 44.9953 120.029C44.9953 92.0869 25.8723 68.6293 0 62Z",
    fill: "#2AC9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9953 120.037C27.0572 120.037 10.9789 127.926 0 140.42V219.469C10.9789 231.955 27.0572 239.852 44.9953 239.852C78.0819 239.852 104.899 213.035 104.899 179.948C104.899 146.862 78.0819 120.045 44.9953 120.045V120.037Z",
    fill: "#03B79E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 113H688V253H758V113Z",
    fill: "#C5E1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 207H617V253H758V207Z",
    fill: "#B2D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 160H617V207H688V160Z",
    fill: "#E4F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.21 12H1084.77V118.031H1233.21V12Z",
    fill: "#C5E1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508 192H1381V262H1508V192Z",
    fill: "#B2D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.21 75.6182H1084.77V118.03H1233.21V75.6182Z",
    fill: "#E4F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.83 118.03H1233.21V266.473H1296.83V118.03Z",
    fill: "#C5E1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.76 118.157H1296.94V202.854H1381.76V118.157Z",
    fill: "#B2D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.77 266.473V118.03H1233.21L1084.77 266.473Z",
    fill: "#C5E1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.21 266.473H1084.77L1233.21 118.03V266.473Z",
    fill: "#B2D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 79.8662V117.923V308.209H1063.62V117.923H1084.83V79.8662H1000Z",
    fill: "#B2D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.83 118.042H1063.62V308.21H1084.83V118.042Z",
    fill: "#E4F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.69 75.6184C1134.27 75.6184 1148.53 61.3769 1148.53 43.8092C1148.53 26.2415 1134.27 12 1116.69 12C1099.1 12 1084.84 26.2415 1084.84 43.8092C1084.84 61.3769 1099.1 75.6184 1116.69 75.6184Z",
    fill: "#B2D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.24 202.855C1362.67 202.855 1381.66 183.866 1381.66 160.443C1381.66 137.019 1362.67 118.03 1339.24 118.03C1315.82 118.03 1296.83 137.019 1296.83 160.443C1296.83 183.866 1315.82 202.855 1339.24 202.855Z",
    fill: "#C5E1FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.75 308.21L1296.92 202.875H1381.75V308.21Z",
    fill: "#E4F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.75 308.21H1296.92V202.875L1381.75 308.21Z",
    fill: "#B2D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.5 243C696.106 243 712 227.33 712 208C712 188.67 696.106 173 676.5 173C656.894 173 641 188.67 641 208C641 227.33 656.894 243 676.5 243Z",
    fill: "#03B79E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.5 249C830.002 249 845 234.225 845 216C845 197.775 830.002 183 811.5 183C792.998 183 778 197.775 778 216C778 234.225 792.998 249 811.5 249Z",
    fill: "#03B79E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778 208C796.225 208 811 193.225 811 175C811 156.775 796.225 142 778 142C759.775 142 745 156.775 745 175C745 193.225 759.775 208 778 208Z",
    fill: "#03B79E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748 249C766.225 249 781 234.002 781 215.5C781 196.998 766.225 182 748 182C729.775 182 715 196.998 715 215.5C715 234.002 729.775 249 748 249Z",
    fill: "#2AC9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 195C148.583 202.428 190.447 236.522 379.875 236.522C582.3 236.522 625.523 211.413 735 211.413C930.435 211.413 1022.87 259.036 1228.5 259.036C1351.38 259.036 1380 253.261 1440 253.261L1439.77 270H0",
    fill: "#03B79E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 183V270H87C87 221.951 48.0489 183 0 183Z",
    fill: "#9EDB65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 267C648.33 267 664 251.33 664 232C664 212.67 648.33 197 629 197C609.67 197 594 212.67 594 232C594 251.33 609.67 267 629 267Z",
    fill: "#9EDB65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 270C751.024 252.424 733.958 240 714 240C694.042 240 676.976 252.419 670 270H757.995H758Z",
    fill: "#9EDB65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.807 144.612C319.894 144.612 348.015 119.082 352.099 86.1006H219.514C223.598 119.082 251.719 144.612 285.807 144.612Z",
    fill: "#03B79E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.111 81.4216L282.785 80.8686L272.5 232.5L281 233L291.111 81.4216Z",
    fill: "#314865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.352 81.7336L323.48 77L279.34 141.081L286.212 145.815L330.352 81.7336Z",
    fill: "#314865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.612 77.8061C352.612 40.9109 322.701 11 285.806 11C248.911 11 219 40.9109 219 77.8061C219 83.5512 219.726 89.1254 221.09 94.445H350.522C351.886 89.1254 352.612 83.5512 352.612 77.8061Z",
    fill: "#9EDB65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_43706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 270,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFotterImg);
export default __webpack_public_path__ + "static/media/FotterImg.522984bcf7833fafabbd391a856abb27.svg";
export { ForwardRef as ReactComponent };